module.exports = __webpack_public_path__ + "img/POP-00014-1.95f98ac3.png";